type GradeRange = {
    label: string;
    min: number;
    max: number;
};

export function customGradeFilter(value: any, filter: any) {
    const gradeFilters: GradeRange[] = [
        {
            label: "90+",
            min: 90,
            max: Number.POSITIVE_INFINITY
        },
        { label: "70-89", min: 70, max: 89 },
        { label: "50-69", min: 50, max: 69 },
        { label: "30-49", min: 30, max: 49 },
        { label: "0-29", min: 0, max: 29 }
    ];

    if (filter === null || !filter.length) return true;

    try {
        value = parseInt(value);
    } catch (err) {
        return false;
    }

    return filter.some((x: any) => {
        const gradeFilter = gradeFilters.find((filter) => filter.label === x);
        if (gradeFilter) {
            return value >= gradeFilter.min && value <= gradeFilter.max;
        }
        return false;
    });
}
